export default import.meta.ROLLDOWN_FILE_URL_ryZFMq15kn5ixB$lOcLxuA